import React from 'react'
import { getHighlightsWithIcons } from '../ProfileIntro/ProfileIntro'

interface Highlight {
  label: string
  icon: string
}

interface CenterCardHighlightsProps {
  highlights: Highlight[]
}

const CenterCardHighlights: React.FC<CenterCardHighlightsProps> = ({
  highlights
}) => (
  <ul className="flex flex-wrap gap-1 md:flex-nowrap md:gap-4">
    {highlights &&
      getHighlightsWithIcons(highlights)
        .filter((highlight) => highlight.icon)
        .slice(0, 3)
        .map((highlight) => (
          <li
            key={highlight.label}
            className="mb-0 flex w-full items-center md:w-auto"
          >
            <img
              className="mr-2 inline w-6 brightness-[25%] contrast-[75%] hue-rotate-[233deg] invert-0 saturate-[200%] sepia-0"
              src={highlight.icon}
              alt={highlight.label}
            />
            <p className="inline align-super text-xs text-gray-800 md:text-sm">
              {highlight.label}
            </p>
          </li>
        ))}
  </ul>
)

export default CenterCardHighlights
